<app-view-title Title="" [showHeader]="true" [overlay]="true"></app-view-title>

<view-content [centered]="true" [fullscreen]="true" [nopadding]="true">
  <location-map #map mode="Local" [locations]="locations" [(selectedLocation)]="selectedLocation" (locationConfirmed)="selectLocation()"></location-map>
</view-content>

<view-actions *ngIf="typeSettings.isShowMenu">
  <button type="button" mat-raised-button color="accent" (click)="mybooking()">{{'Intellitrailer_Home_Home_cmdMyPage' | translate: 'My reservations'}}</button>
</view-actions>
